module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/130.02e605e5.png";